import React from 'react';
import { AddDeviationsPayload } from '../../actions';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import AddIcon16 from '@wix/da-ds/pkg/Icons/16x16/Add';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import IconButtonWithBackground from '@wix/da-ds/pkg/Buttons/IconButton/IconButtonWithBackground';
import { useTranslation } from 'react-i18next';
import InnerMediaSelector from '../InnerMediaSelector';
import { useCurrentMediaSource } from '../../_hocs/withCurrentMediaSource';
import { MediaSourceType } from '../../types';

export interface Props {
  plusOnly?: boolean;
  disabled?: boolean;
  limit?: number;
  currentDeviationIds?: number[];
  isShowingAddDeviationsPopup?: boolean;
  showAddDeviationsPopup(): void;
  hideAddDeviationsPopup(): void;
  addDeviations(payload: AddDeviationsPayload): void;
}

export const AddDeviationsButton: React.FC<React.PropsWithChildren<Props>> = ({
  disabled,
  limit,
  plusOnly,
  currentDeviationIds,
  isShowingAddDeviationsPopup,
  showAddDeviationsPopup,
  hideAddDeviationsPopup,
  addDeviations: addDeviationsAction,
}) => {
  const { currentMediaSource } = useCurrentMediaSource();
  const { t } = useTranslation();
  const onSelect = deviations => {
    addDeviationsAction(deviations);
    hideAddDeviationsPopup();
  };
  return (
    <>
      {plusOnly ? (
        <IconButtonWithBackground
          size="medium"
          aria-label={t(
            currentMediaSource === MediaSourceType.TIER_POSTS
              ? 'mediapopup.addPosts'
              : 'mediapopup.addDeviations'
          )}
          icon={AddIcon16}
          onClick={showAddDeviationsPopup}
          disabled={disabled}
        />
      ) : (
        <GhostButton
          variant="main"
          size="large"
          onClick={showAddDeviationsPopup}
          disabled={disabled}
          icon={AddIcon}
        >
          {t(
            currentMediaSource === MediaSourceType.TIER_POSTS
              ? 'mediapopup.addPosts'
              : 'mediapopup.addDeviations'
          )}
        </GhostButton>
      )}
      {isShowingAddDeviationsPopup && (
        <InnerMediaSelector
          onSelect={onSelect}
          onClose={hideAddDeviationsPopup}
          selectionLimit={limit}
          title={t(
            currentMediaSource === MediaSourceType.TIER_POSTS
              ? 'mediapopup.addPosts'
              : 'mediapopup.addDeviations'
          )}
          submitBtnLabel={t('mediapopup.add')}
          ignoreDeviationIds={currentDeviationIds}
        />
      )}
    </>
  );
};
AddDeviationsButton.displayName = 'AddDeviationsButton';

export default AddDeviationsButton;
